module.exports = __webpack_public_path__ + "static/img/result1.d7ed2d51.png";